import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export const codeInputVariants = cva(
    "code-input flex flex-wrap data-[invalid=true]:text-destructive [&>.group]:flex gap-y-3",
    {
        variants: {
            size: {
                normal: ["gap-5 [&>.group]:gap-2"],
                big: ["gap-9 [&>.group]:gap-3"],
            },
        },
        defaultVariants: {
            size: "normal",
        },
    },
)

export const codeInputBoxVariants = cva(
    "flex-none w-10 h-10 !text-lg text-primary font-semibold text-center uppercase",
    {
        variants: {
            size: {
                normal: ["w-10"],
                big: ["w-12 h-12 !text-xl"],
            },
        },
        defaultVariants: {
            size: "normal",
        },
    },
)

export type CodeInputVariants = VariantProps<typeof codeInputVariants>
